module.exports = __webpack_public_path__ + "img/red-book-code.e0e894f3.png";